export default __webpack_public_path__ + "static/media/abOntimeLogoWithoutDS.a2ab5694.png";